// @flow
import * as general from "./general";

export default general;
